import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment'
import styled from "styled-components";
import BedroomParentIcon from '@mui/icons-material/BedroomParent';


const SpanTitle = styled.span`
    font-size:18px;
    color:#4682B4;
    font-weight:bold;
`
const SpanData = styled.span`
    margin-right:50px;
    font-size:18px;
    color:#4682B4;
    font-weight:bold;
    display:inline-block;
    width:300px;
`
const FooterGroup = styled.p`
    text-align:right;
    font-size:18px;
    color:#4682B4;
    font-weight:bold;
`
const HeaderTable = styled.div`
    text-align:center;
    color:#4682B4;
    font-size:24px;
`

const IconHeader = styled(BedroomParentIcon)`
    vertical-align:text-bottom;
    margin-right:10px;
    width: 30px !important;
    height: 30px !important;
`

const HeaderTitulo = styled.span`
    margin-bottom:10px;
`


const TabelaHoteis = (props) => {
    const [hoteis, setHoteis] = useState([]);
    const [totalDiaria, setTotalDiaria] = useState(0.00);
    const [totalTotalizadorDiaria, setTotalTotalizadorDiaria] = useState(0.00);
    const [totalTaxa, setTotalTaxa] = useState(0.00);
    const [totalCartao, setTotalCartao] = useState(0.00);
    const [totalComissao, setTotalComissao] = useState(0.00);
    const [totalIncentivo, setTotalIncentivo] = useState(0.00);
    const [totalDesconto, setTotalDesconto] = useState(0.00);
    const [totalFee, setTotalFee] = useState(0.00);
    const [totalLiquido, setTotalLiquido] = useState(0.00);
    const [totalExtras, setTotalExtras] = useState(0.00);

    useEffect(() => {
        setHoteis(props.fatura.hoteis);
        setTotalDiaria(formatNumberPosMount(props.fatura.totalDiariaHotel));
        setTotalTaxa(formatNumberPosMount(props.fatura.totalTaxaHotel));
        setTotalCartao(formatNumberPosMount(props.fatura.totalCartaoHotel));
        setTotalComissao(formatNumberPosMount(props.fatura.totalComissaoHotel));
        setTotalIncentivo(formatNumberPosMount(props.fatura.totalIncentivoHotel));
        setTotalDesconto(formatNumberPosMount(props.fatura.totalDescontoHotel));
        setTotalFee(formatNumberPosMount(props.fatura.totalFeeHotel));
        setTotalLiquido(formatNumberPosMount(props.fatura.totalLiquidoHotel));
        setTotalTotalizadorDiaria(formatNumberPosMount(props.fatura.totalTotalizadorDiariaHotel));
        setTotalExtras(formatNumberPosMount(props.fatura.totalExtrasHotel));
    }, [hoteis, totalTaxa, totalCartao, totalComissao, totalIncentivo, totalDesconto, totalFee, totalLiquido, props.fatura.hoteis,
        props.fatura.totalTarifaGeral,
        props.fatura.totalTaxa, props.fatura.totalCartao,
        props.fatura.totalComissao, props.fatura.totalIncentivo,
        props.fatura.totalDesconto, props.fatura.totalImposto,
        props.fatura.totalFee, props.fatura.totalTxacrt, props.fatura.totalTxDu,
        props.fatura.totalLiquido, props.fatura.TabelaHoteis, props.fatura.totalDiariaHotel,
        props.fatura.totalTaxaHotel, props.fatura.totalCartaoHotel, props.fatura.totalComissaoHotel,
        props.fatura.totalIncentivoHotel, props.fatura.totalDescontoHotel, props.fatura.totalFeeHotel,
        props.fatura.totalLiquidoHotel, props.fatura.totalTotalizadorDiariaHotel, props.fatura.totalExtrasHotel]);


    const formatNumberPosMount = (number) => {
        const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        const formatNumber = new Intl.NumberFormat('pt-BR', options)
        return number !== "undefined" ? formatNumber.format(number) : 0.00;
    }

    const header = (
        <HeaderTable>
            <IconHeader /><HeaderTitulo>HOTÉIS</HeaderTitulo>
        </HeaderTable>
    );

    const reactFooter = (totalizadores) => {
        return (
            <React.Fragment>
                <td style={{ minWidth: '400px' }}></td>
                <td style={{ minWidth: '150px' }}></td>
                <td style={{ minWidth: '250px' }}></td>
                <td style={{ minWidth: '150px' }}></td>
                <td style={{ minWidth: '150px' }}></td>
                <td style={{ minWidth: '150px' }}></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>Total:</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.diaria}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.totalDiaria}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.totalTaxa}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.extras}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.cartao}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.incentivo}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.comissao}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.desconto}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.fee}</FooterGroup></td>
                <td style={{ minWidth: '150px' }}><FooterGroup>{totalizadores.liquido}</FooterGroup></td>
            </React.Fragment>
        );
    }

    const footerTemplate = (data) => {
        let totalizadores = countOnibusTotal(data.grupo);

        return reactFooter(totalizadores);
    }

    const headerTemplate = (data) => {
        return (
            <React.Fragment>
                <SpanTitle>Hotel:&nbsp;</SpanTitle><SpanData>{data.nomefnsv}</SpanData>
                <SpanTitle>Tipo:&nbsp;</SpanTitle><SpanData>{data.tipoFormatado}</SpanData>
            </React.Fragment>
        );
    }

    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options)

    const extrasBodyTemplate = (rowData) => {
        let value = rowData.valextcl;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const cartaoBodyTemplate = (rowData) => {
        let value = rowData.valcrtcl;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const comissaoBodyTemplate = (rowData) => {
        let value = rowData.valrpcl;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const incentivoBodyTemplate = (rowData) => {
        let value = rowData.valcmcl;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const descontoBodyTemplate = (rowData) => {
        let value = rowData.valdesc;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const liquidoBodyTemplate = (rowData) => {
        let value = rowData.valarec;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const feeBodyTemplate = (rowData) => {
        let value = rowData.txadcli;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const taxaBodyTemplate = (rowData) => {
        let value = rowData.taxa;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const totalDiariasBodyTemplate = (rowData) => {
        let value = rowData.tarifa;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const diariaBodyTemplate = (rowData) => {
        let value = rowData.tarifpro;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const paxBodyTemplate = (rowData) => {

        let value = rowData.pax;
        var passageiros = value.split("%");
        return (
            <div className="flex flex-wrap gap-2">
                {passageiros.map(pax => <><span>{pax}</span><br></br></>)}
            </div>
        );
    }

    const dataEmissaoBodyTemplate = (rowData) => {
        return moment(rowData.emissao).format('DD/MM/YYYY')
    }

    const checkinBodyTemplate = (rowData) => {
        return moment(rowData.datain).format('DD/MM/YYYY')
    }

    const checkoutBodyTemplate = (rowData) => {
        return moment(rowData.dataout).format('DD/MM/YYYY')
    }

    const countOnibusTotal = (grupo) => {
        let totalDiaria = 0;
        let totalTotalizadorDiaria = 0;
        let totalTaxa = 0;
        let totalExtras = 0;
        let totalCartao = 0;
        let totalIncentivo = 0;
        let totalComissao = 0;
        let totalDesconto = 0;
        let totalFee = 0;
        let totalLiquido = 0;

        if (hoteis) {
            for (let hotel of hoteis) {
                if (grupo === undefined || hotel.grupo === grupo) {
                    totalDiaria += hotel.tarifpro;
                    totalTotalizadorDiaria += hotel.tarifa;
                    totalTaxa += hotel.taxa;
                    totalCartao += hotel.valcrtcl;
                    totalExtras += hotel.valextcl;
                    totalIncentivo += hotel.valcmcl;
                    totalComissao += hotel.valrpcl;
                    totalDesconto += hotel.valdesc;
                    totalFee += hotel.txadcli;
                    totalLiquido += hotel.valarec;
                }
            }
        }
        return {
            diaria: formatNumber.format(totalDiaria),
            totalDiaria: formatNumber.format(totalTotalizadorDiaria),
            totalTaxa: formatNumber.format(totalTaxa),
            cartao: formatNumber.format(totalCartao),
            extras: formatNumber.format(totalExtras),
            incentivo: formatNumber.format(totalIncentivo),
            comissao: formatNumber.format(totalComissao),
            desconto: formatNumber.format(totalDesconto),
            fee: formatNumber.format(totalFee),
            liquido: formatNumber.format(totalLiquido),
        };
    }

    return (
        <DataTable 
            value={hoteis}
            header={header} 
            rowGroupMode="subheader" 
            groupRowsBy="grupo" 
            scrollable 
            scrollHeight="500px" 
            tableStyle={{ minWidth: '2900px' }}
            size="small"  
            sortMode="single" 
            sortOrder={1} 
            rowGroupHeaderTemplate={headerTemplate}  
            rowGroupFooterTemplate={footerTemplate} 
            stripedRows 
            >
            <Column style={{ minWidth: '400px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} headerStyle={{ backgroundColor: '#4682B4', color: 'white'}} field={paxBodyTemplate} header="Nome (s)"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} headerStyle={{ backgroundColor: '#4682B4', color: 'white'}} field={dataEmissaoBodyTemplate} header="EMISSÃO"></Column>
            <Column style={{ minWidth: '250px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} headerStyle={{ backgroundColor: '#4682B4', color: 'white'}} field="numresv" header="Nº RESERVA"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} headerStyle={{ backgroundColor: '#4682B4', color: 'white'}} field={checkinBodyTemplate} header="CHECKIN"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} headerStyle={{ backgroundColor: '#4682B4', color: 'white'}} field={checkoutBodyTemplate} header="CHECKOUT"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} headerStyle={{ backgroundColor: '#4682B4', color: 'white'}} field="quanpax" header="Nº PAX"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer="Total Geral:" headerStyle={{ backgroundColor: '#4682B4', color: 'white'}} field="qtddias" header="Nº DIÁRIAS"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalDiaria} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={diariaBodyTemplate} header="DIÁRIA R$"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalTotalizadorDiaria} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={totalDiariasBodyTemplate} header="TOTAL DIÁRIAS"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalTaxa} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={taxaBodyTemplate} header="TAXA"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalExtras} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={extrasBodyTemplate} header="EXTRAS"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalCartao} headerStyle={{ backgroundColor: '#4682B4', color: 'white'}} field={cartaoBodyTemplate} header="CARTÃO"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalIncentivo} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={incentivoBodyTemplate} header="INCENTIVO"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalComissao} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={comissaoBodyTemplate} header="COMISSÃO"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalDesconto} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={descontoBodyTemplate} header="DESCONTO"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalFee} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={feeBodyTemplate} header="FEE"></Column>
            <Column style={{ minWidth: '150px' }} footerStyle={{backgroundColor: '#4682B4', color: 'white'}} footer={totalLiquido} headerStyle={{ backgroundColor: '#4682B4', color: 'white' }} field={liquidoBodyTemplate} header="LÍQUIDO"></Column>
        </DataTable>
    );
}

export default TabelaHoteis;